import useSeoMeta from '../hooks/useSeoMeta';

const SECTION = ({ title, children }) => (
  <div style={{ marginBottom: '36px' }}>
    <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: '18px', fontWeight: 700, color: '#111', marginBottom: '12px', paddingBottom: '8px', borderBottom: '1px solid #f0f0f0' }}>{title}</h2>
    <div style={{ fontSize: '14px', color: '#555', lineHeight: 1.8 }}>{children}</div>
  </div>
);

export default function Confidentialite() {
  useSeoMeta(null, { title: 'Politique de confidentialité — Tech Talent Accelerator', desc: 'Politique de confidentialité et protection des données personnelles de TTA.' });

  return (
    <main style={{ padding: '80px 40px', maxWidth: '760px', margin: '0 auto' }}>
      <div className="section-eyebrow">Protection des données</div>
      <h1 style={{ fontFamily: "'Sora',sans-serif", fontSize: '36px', fontWeight: 800, color: '#111', marginBottom: '8px' }}>
        Politique de confidentialité
      </h1>
      <p style={{ fontSize: '14px', color: '#888', marginBottom: '48px' }}>Dernière mise à jour : avril 2026</p>

      <SECTION title="Responsable du traitement">
        <p><strong>Tech Talent Accelerator (TTA)</strong> — Abidjan, Côte d'Ivoire</p>
        <p>Contact DPO : <a href="mailto:contact@techtalentaccelerator.com" style={{ color: 'var(--mid)' }}>contact@techtalentaccelerator.com</a></p>
      </SECTION>

      <SECTION title="Données collectées">
        <p>Nous collectons uniquement les données que vous nous transmettez volontairement via :</p>
        <ul style={{ marginTop: '8px', paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <li>Le formulaire de contact (nom, email, sujet, message, type de demande)</li>
          <li>Le formulaire d'inscription à la newsletter (email)</li>
        </ul>
        <p style={{ marginTop: '8px' }}>Aucune donnée n'est collectée passivement (pas de cookies analytiques, pas de pixel de tracking).</p>
      </SECTION>

      <SECTION title="Finalités du traitement">
        <ul style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <li>Traiter et répondre à vos demandes de contact</li>
          <li>Vous envoyer des informations sur les prochains programmes TTA (newsletter)</li>
          <li>Gérer les candidatures aux programmes financés</li>
        </ul>
      </SECTION>

      <SECTION title="Durée de conservation">
        <p>Vos données de contact sont conservées pendant <strong>2 ans</strong> à compter de votre dernière interaction. Les données de candidature sont conservées pendant la durée du programme concerné.</p>
      </SECTION>

      <SECTION title="Destinataires des données">
        <p>Vos données sont accessibles uniquement à l'équipe interne de TTA. Elles ne sont ni vendues, ni louées, ni transmises à des tiers à des fins commerciales.</p>
        <p style={{ marginTop: '8px' }}>Elles peuvent être partagées avec nos bailleurs institutionnels (GIZ, FORPRODE, etc.) uniquement dans le cadre des programmes pour lesquels vous avez candidaté, et avec votre consentement.</p>
      </SECTION>

      <SECTION title="Vos droits">
        <p>Conformément aux lois applicables sur la protection des données, vous disposez des droits suivants :</p>
        <ul style={{ marginTop: '8px', paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <li><strong>Droit d'accès</strong> : obtenir une copie de vos données</li>
          <li><strong>Droit de rectification</strong> : corriger des données inexactes</li>
          <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données</li>
          <li><strong>Droit d'opposition</strong> : vous opposer à un traitement</li>
        </ul>
        <p style={{ marginTop: '12px' }}>Pour exercer ces droits, contactez-nous à <a href="mailto:contact@techtalentaccelerator.com" style={{ color: 'var(--mid)' }}>contact@techtalentaccelerator.com</a>. Nous répondons sous 30 jours.</p>
      </SECTION>

      <SECTION title="Sécurité">
        <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données : connexions HTTPS, accès restreints, hébergement sécurisé chez Hostinger.</p>
      </SECTION>

      <SECTION title="Modifications">
        <p>Cette politique peut être mise à jour. En cas de modification substantielle, nous l'indiquerons sur cette page avec une nouvelle date de mise à jour.</p>
      </SECTION>
    </main>
  );
}
